import {
  MODELS_REQUESTED,
  GET_MODELS_SUCCESS,
  GET_MODELS_FAILED,
  SAVE_PAGE_STATE,
  ARGS_MODEL_EXAMPLE,
  SAVE_PAGE_PROGRESS,
  GET_FAVOURITES_MODELS,
  FAVOURITES_MODELS_REQUESTED,
  GET_CURRENT_MODEL,
  NEGATIVE_ARGS_MODEL_EXAMPLE,
  CURRENT_MODEL_REQUESTED,
  GET_CURRENT_MODEL_FAILED,
  SET_VIEW_MODE,
} from '../types/models.type'

const intialState = {
  data: null,
  loading: false,
  currentModelLoading: false,
  error: null,
  pageState: null,
  argsModelExamples: null,
  negativePromptExamples: null,
  negativePromptLoading: false,
  negativePromptError: null,
  pageProgress: null,
  favoriteModels: null,
  favoriteLoading: false,
  currentModel: false,
  viewMode: 'stacked',
}

const modelsReducer = (state = intialState, action) => {
  switch (action.type) {
    case MODELS_REQUESTED:
      return { ...state, loading: true, error: null }
    case CURRENT_MODEL_REQUESTED:
      return { ...state, currentModelLoading: true }
    case GET_MODELS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
      }
    case GET_CURRENT_MODEL:
      return {
        ...state,
        currentModel: action.payload,
      }

    case GET_CURRENT_MODEL_FAILED:
      return {
        ...state,
        currentModelLoading: false,
        data: null,
        error: action.payload,
      }
    case GET_MODELS_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      }
    case ARGS_MODEL_EXAMPLE:
      return { ...state, argsModelExamples: action.payload }
    case NEGATIVE_ARGS_MODEL_EXAMPLE:
      return { ...state, negativePromptExamples: action.payload }
    case SAVE_PAGE_STATE:
      return {
        ...state,
        pageState: action.payload,
      }
    case SAVE_PAGE_PROGRESS:
      return {
        ...state,
        pageProgress: action.payload,
      }
    case FAVOURITES_MODELS_REQUESTED:
      return {
        ...state,
        favoriteLoading: true,
      }
    case GET_FAVOURITES_MODELS:
      return {
        ...state,
        favoriteModels: action.payload || [],
        favoriteLoading: false,
      }
    case SET_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload,
      }

    default:
      return state
  }
}

export default modelsReducer
